import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface iMessage {
  value: string;
  timeout?: number;
  type: 'success' | 'error' | 'warning' | 'info';
  namespace?: string;
}

const initialState: iMessage = {
  value: '',
  timeout: 0,
  type: 'success',
  namespace: null,
};

export const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<iMessage>) => {
      return action.payload;
    },
    hideMessage: (state) => {
      return initialState;
    },
  },
});

export const { setMessage, hideMessage } = messageSlice.actions;

export const selectMessage = (state: RootState) => state.message;

export default messageSlice.reducer;
